import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalAccountsTable from './portal-accounts-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-portal-admin-haulier-drivers')) {
  ReactDOM.render(<PortalAccountsTable
    url= "/api/v1/portal/portal-admin/portal-haulier-drivers"
    message_if_none = 'No driver accounts in system yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-portal-admin-haulier-drivers'));
}
